//@ts-nocheck
import React from 'react';
import { Star } from './Star';
import './Stars.css';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';

export type StarsProps = {
  stars: number;
};
export const Stars = ({ stars }: StarsProps) => {
  const { __t } = useTranslation();
  const starsCount = __t('scoreResult', 'END_GAME').replace('[x]', stars);
  return (
    <div className="StarsContainer" alt={starsCount}>
      <div className="StarColumn">
        {/* <div className="StarPadding"></div> */}
        <Star
          rotation={-30}
          isActive={true}
          animationDelay={0}
          starId={1}
          style={{
            position: 'relative',
            left: '2vw',
            height: 'unset',
            width: 'var(--star-width)',
          }}
        ></Star>
      </div>
      <div className="StarColumn">
        {/* <div className="StarPadding"></div> */}
        <Star
          rotation={0}
          isActive={stars === 2 || stars === 3}
          animationDelay={0.3}
          starId={2}
          style={{
            position: 'relative',
            height: 'unset',
            width: 'var(--star-width)',
          }}
        ></Star>
      </div>
      <div className="StarColumn">
        {/* <div className="StarPadding"></div> */}
        <Star
          rotation={30}
          isActive={stars === 3}
          animationDelay={0.6}
          starId={3}
          style={{
            position: 'relative',
            right: '2vw',
            height: 'unset',
            width: 'var(--star-width)',
          }}
        ></Star>
      </div>
    </div>
  );
};
